<template>
    <div class="wrapper-title">
        <h2 style="font-size: 13px; letter-spacing: .25px;">
            {{title}}
        </h2>
    </div>
</template>

<script>
    import { mapState } from 'vuex';
    export default {
        name: 'DatasetTitle',
        props: ['title'],
        computed: {
            ...mapState(['storyActive', 'paragraphActive']),
        }
    }
</script>

<style lang="scss">
    @import '../assets/style/main.scss'; 

    .wrapper-title {
        position: absolute;
        top: 10px;
        left: 35px;
    }
</style>